export default "__VITE_ASSET__fnkYRYHd__"